import React from "react";
import { Link } from "react-router-dom";
import { push as SlideMenu } from "react-burger-menu";
import { useQueryParams } from "utils/hooks/useQueryParams";
import MenuIcon from "../images/MenuIcon";
import SocialLinks from "./SocialLinks";

// The styling for the button element underneath everything is not exposed.
// See the file in the node_module, /react-burger-menu/lib/BurgerIcon.js
const menuStyles = {
  bmBurgerButton: {
    right: 20,
    width: "24px",
    height: "auto",
    outline: "none",
    zIndex: 40,
    position: "relative",
  },
  bmBurgerBars: {
    background: "black",
    borderRadius: 2,
  },
  bmBurgerBarsHover: {
    background: "#a90000",
  },
  bmCrossButton: {
    height: "28px",
    width: "28px",
  },
  bmCross: {
    background: "white",
  },
  bmMenuWrap: {
    position: "fixed",
    height: "100%",
    top: 0,
  },
  bmMenu: {
    background: "black",
    padding: "2.5em 1.5em 0",
    fontSize: "1.15em",
  },
  bmMorphShape: {
    fill: "#373a47",
  },
  bmItemList: {
    color: "white",
    padding: "0.8em",
  },
  bmItem: {
    display: "inline-block",
    paddingTop: 8,
    textAlign: "center",
  },
  bmOverlay: {
    background: "rgba(0, 0, 0, 0.3)",
    right: "1px", // Without this, overlay appears on the right side of side menu which is out of screen.
  },
};

const BoostMenu = (props) => {
  const {
    handleToggle = () => {},
    hidden = false,
  } = props;

  const withQueryParams = useQueryParams();

  return (
    <SlideMenu
      className="burger-menu"
      right
      onStateChange={(state) => {
        handleToggle(state);
      }}
      styles={menuStyles}
      customBurgerIcon={
        <MenuIcon
          style={{ outline: "none" }}
          className="lg:hidden"
        />
      }
      outerContainerId="outer-container"
      pageWrapId="page-wrap"
      burgerButtonClassName={`${hidden ? "hidden" : "lg:hidden"}`}
    >
      <a
        href={`${process.env.REACT_APP_DOMAIN}/dashboard/login?redirect_uri=/boost&fromBoost=true`}
        className="menu-item  w-full outline-none select-none hover:text-boost-purple-alt border-b pb-3 mb-3 border-gray-900"
      >
        <i className="fa fa-rocket mr-2" /> Sign in
      </a>
      <Link
        to={withQueryParams("/boost-how-it-works")}
        className="menu-item w-full outline-none select-none hover:text-boost-purple-alt"
      >
        How It Works
      </Link>
      <Link
        to={withQueryParams("/boost-faq")}
        className="menu-item w-full outline-none select-none hover:text-boost-purple-alt"
      >
        FAQs
      </Link>
      <Link
        to={withQueryParams("/boost-pricing")}
        className="menu-item w-full outline-none select-none hover:text-boost-purple-alt"
      >
        Pricing
      </Link>
      <a
        href="https://tomocredit.com/blog/"
        className="menu-item w-full outline-none select-none hover:text-boost-purple-alt"
      >
        Blog
      </a>
      <Link
        to={withQueryParams("/ai")}
        className="menu-item w-full outline-none select-none hover:text-boost-purple-alt"
      >
        TomoAI
      </Link>
      <Link
        to={withQueryParams("/boost/ai")}
        className="menu-item w-full outline-none select-none hover:text-boost-purple-alt"
      >
        TomoIQ
      </Link>
      <Link
        to={withQueryParams("/boost/small-business")}
        className="menu-item w-full outline-none select-none hover:text-boost-purple-alt"
      >
        Business
      </Link>
      <SocialLinks className="w-full" boost />
    </SlideMenu>
  );
};

export default BoostMenu;
